import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OccupationsService } from '../../data-access/occupations.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-occupation-category-modal',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './occupation-category-modal.component.html',
})
export class OccupationCategoryModalComponent implements OnInit {
    @Input() occupationCode!: number;
    @Input() occupationDescription!: string;
    @Input() currentCategory?: number;

    form!: FormGroup;
    loading = false;

    categoryOptions = [
        { label: 'Categoría 1', value: 1 },
        { label: 'Categoría 2', value: 2 },
        { label: 'Categoría 3', value: 3 },
    ];

    constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private occupationsService: OccupationsService
    ) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            category: [this.currentCategory || 1, Validators.required],
        });
    }

    async save() {
        if (this.form.invalid) return;

        this.loading = true;
        try {
            const category = this.form.value.category;
            await lastValueFrom(
                this.occupationsService.updateCategory(this.occupationCode, category)
            );
            this.activeModal.close(category);
        } catch (e) {
            console.error('Error updating category', e);
        } finally {
            this.loading = false;
        }
    }

    dismiss() {
        this.activeModal.dismiss();
    }
}
